import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

// Your fixed path
import loadingAnimation from '../src/assets/loading-animation.json';

interface AppLoadingScreenProps {
  onComplete: () => void;
}

const AppLoadingScreen: React.FC<AppLoadingScreenProps> = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Keep the background timing logic the same so it loads smoothly
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            onComplete();
          }, 800);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 150);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 bg-white z-[9999] flex items-center justify-center">
      
      <div className="w-[300px] h-[300px] flex items-center justify-center">
        <Lottie 
          animationData={loadingAnimation} 
          loop={true} 
        />
      </div>
    </div>
  );
};

export default AppLoadingScreen;
